export const BREEDER = 'breeder';
export const REGISTRY_WARDEN = 'registry-warden';
export const PANON_ADMIN = 'panon-admin';
